import { chatChannelRouteDTOSchema, chatChannelRoutesDTOSchema, chatChannelsDTOSchema, chatIntegrationDTOSchema, chatIntegrationInstallDTOSchema, chatIntegrationsDTOSchema, chatIntegrationTestResultDTOSchema, chatUnmatchedHostsDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const BASE = `${WEB_API_PREFIX}/tenant/integrations`;
const listSchema = dataEnvelopeSchema(chatIntegrationsDTOSchema);
const integrationSchema = dataEnvelopeSchema(chatIntegrationDTOSchema);
const installSchema = dataEnvelopeSchema(chatIntegrationInstallDTOSchema);
const testSchema = dataEnvelopeSchema(chatIntegrationTestResultDTOSchema);
const unmatchedHostsSchema = dataEnvelopeSchema(chatUnmatchedHostsDTOSchema);
const channelsSchema = dataEnvelopeSchema(chatChannelsDTOSchema);
const channelRoutesSchema = dataEnvelopeSchema(chatChannelRoutesDTOSchema);
const channelRouteSchema = dataEnvelopeSchema(chatChannelRouteDTOSchema);
export function createIntegrationsResource(transport) {
    return {
        async list() {
            return (await transport.request({ path: BASE, schema: listSchema })).data;
        },
        async install(provider) {
            return (await transport.request({ method: 'POST', path: `${BASE}/${encodeURIComponent(provider)}/install`, schema: installSchema })).data;
        },
        async complete(provider, input) {
            return (await transport.request({
                method: 'POST',
                path: `${BASE}/${encodeURIComponent(provider)}/complete`,
                schema: integrationSchema,
                body: input,
            })).data;
        },
        async update(id, input) {
            return (await transport.request({ method: 'PATCH', path: `${BASE}/${encodeURIComponent(id)}`, schema: integrationSchema, body: input })).data;
        },
        async disconnect(id) {
            await transport.request({ method: 'DELETE', path: `${BASE}/${encodeURIComponent(id)}`, schema: z.undefined() });
        },
        async sendTest(id) {
            return (await transport.request({ method: 'POST', path: `${BASE}/${encodeURIComponent(id)}/test`, schema: testSchema })).data;
        },
        async unmatchedHosts(id) {
            return (await transport.request({ path: `${BASE}/${encodeURIComponent(id)}/unmatched-hosts`, schema: unmatchedHostsSchema })).data;
        },
        async channels(id) {
            return (await transport.request({ path: `${BASE}/${encodeURIComponent(id)}/channels`, schema: channelsSchema })).data;
        },
        async channelRoutes(id) {
            return (await transport.request({ path: `${BASE}/${encodeURIComponent(id)}/channel-routes`, schema: channelRoutesSchema })).data;
        },
        async addChannelRoute(id, input) {
            return (await transport.request({
                method: 'POST',
                path: `${BASE}/${encodeURIComponent(id)}/channel-routes`,
                schema: channelRouteSchema,
                body: input,
            })).data;
        },
        async updateChannelRoute(id, routeId, input) {
            return (await transport.request({
                method: 'PATCH',
                path: `${BASE}/${encodeURIComponent(id)}/channel-routes/${encodeURIComponent(routeId)}`,
                schema: channelRouteSchema,
                body: input,
            })).data;
        },
        async removeChannelRoute(id, routeId) {
            await transport.request({
                method: 'DELETE',
                path: `${BASE}/${encodeURIComponent(id)}/channel-routes/${encodeURIComponent(routeId)}`,
                schema: z.undefined(),
            });
        },
    };
}
//# sourceMappingURL=integrations.js.map